module.exports = __webpack_public_path__ + "static/img/ai-assistant.3c04e4c3.webp";